/* eslint semi: 1 */

import { fromPairs, keys, isEmpty } from 'lodash';
import { CLOSE_DIALOG } from '@/components/common/dialog-popup/dialog-popup';
import USStates from '@/static/states/us_states.json';

export const CLOSE_PLAN_UPGRADE_EVENT = 'PlanUpgradeDialogClose';

export const PLAN_UPGRADE_STEPS = {
  STEP_OVERVIEW: 'overview',
  STEP_BILLING_DETAILS: 'billingDetails',
  STEP_PAYMENT: 'payment',
  STEP_PAYMENT_DATATRANS_LIGHTBOX: 'paymentDatatransLightbox',
  STEP_PAYMENT_SUCCESSFUL: 'paymentSuccessful',
  STEP_UPGRADE_TO_PREMIUM: 'upgradeToPremium',
  CLOSE: CLOSE_DIALOG
};

export const PROGRESS_SCENARIOS = {
  UPGRADE: [
    { id: PLAN_UPGRADE_STEPS.STEP_OVERVIEW, i18nLabel: 'planUpgrade.Overview' },
    { id: PLAN_UPGRADE_STEPS.STEP_BILLING_DETAILS, i18nLabel: 'planUpgrade.BillingDetails' },
    { id: PLAN_UPGRADE_STEPS.STEP_PAYMENT, i18nLabel: 'planUpgrade.Payment' }
  ]
};

// let's have it to avoid typos in the code
export const PROGRESS_SCENARIO_OPTIONS = fromPairs(keys(PROGRESS_SCENARIOS).map(k => [k, k]));

export const PLAN_NAMES = {
  PREMIUM: 'premium'
};

export const getStateName = (abbreviation) => {
  const state = USStates.find(state => state.abbreviation === abbreviation);

  if (!isEmpty(state)) {
    return state.name;
  }

  return '';
};
